import { useEffect, useState } from "react";

/** Hora actual que se actualiza cada `intervalMs` (null = detenido). Para cuentas regresivas. */
export function useNow(intervalMs: number | null): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (intervalMs === null) return;
    setNow(Date.now());
    const t = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs]);
  return now;
}

/** Título de la pestaña: "Buscar · SENTINEL". Nunca incluye datos de la búsqueda. */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title ? `${title} · SENTINEL` : "SENTINEL";
  }, [title]);
}

/** Valor retrasado (p. ej. filtros de texto que disparan consultas). */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
